import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { DialogMessage } from './Widgets/DialogMessage';
class TEST4 extends Component {
    constructor(props) {
        super(props);
        this.state = {
            input: '',
            scannedStuff: [],
            showDialog: false,
            isErrorMessage: false,
            actionDialog: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            summaryActive: false
        };
        this.handleInputChange = this.handleInputChange.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.addScannedTote = this.addScannedTote.bind(this);
        this.addScannedToteCallback = this.addScannedToteCallback.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
    }

    componentDidMount() {
        this.focusOnInput();
    }

    handleInputChange(event) {
        event.preventDefault();
        const target = event.target;
        const value = target.value;
        this.setState({
            input: value.toUpperCase()
        });
        this.focusOnInput();
    }

    focusOnInput() {
        document.getElementById('scanInput').focus();
    }

    addScannedTote(e) {
        e.preventDefault();
        this.setState({
            showDialog: true,
            dialogFullScreen: false,
            dialogContent: (<form className="slotInput" onSubmit={(e) => this.addScannedToteCallback(e)} >
                <label htmlFor="slotNum"></label>
                <input
                    autoFocus
                    autoComplete="off"
                    type="text"
                    id="slotNum"
                    name="slotNum"
                    inputMode="none"
                />
            </form>),
            dialogTitle: "Scan Slot Number",
            isErrorMessage: false,
            actionDialog: true,
            summaryActive: false
        });
    }

    addScannedToteCallback(e) {
        e.preventDefault();
        var slotNum = e.target.elements.slotNum.value;
        var scannedStuff = this.state.scannedStuff;
        scannedStuff.push(this.state.input);
        scannedStuff.push(slotNum);
        this.setState({
            showDialog: false,
            dialogContent: "",
            input: ''
        });
        this.focusOnInput();
    }

    closeDialog(slotVerified = false) {
        console.log("CLOSING DIALOG", this.state);
        console.log("SLOT VERIFIED", slotVerified);
        console.log("HERE", this.state.verifyingSlot && !slotVerified)
        if (this.state.verifyingSlot && slotVerified != true) {
            this.updateInstructions("Slot not Verified");
            this.playFailure();
            this.setState({
                verifyingSlot: false,
                scannedItemInput: ""
            });
        }
        if (this.state.summaryActive) {
            this.switchStage('Prep');
        }
        this.setState({
            showDialog: false
        });
        if (this.state.badSession) {
            window.location.reload();
        }
        setTimeout(this.focusOnInput, 10);
    }

    render() {
        return (
            <div>
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    actionDialog={this.state.actionDialog}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                <form action="#">
                    <input className="scanIdentifierInput" autoComplete="off" type="text" id="scanInput" name="scanInput" placeholder="Scan or Enter Tote #" value={this.state.input} onChange={this.handleInputChange}></input>
                    <button hidden type="submit" onClick={this.addScannedTote}/>
                </form>
                <h1>Scanned Stuff</h1>
                {
                    this.state.scannedStuff.map(scannedThing => {
                        return (
                            <>
                                <div>*{scannedThing}*</div>
                                <br />
                            </>
                        );
                    })
                }
            </div>
           
        );
    }
}

export default withRouter(TEST4);
